import { useCallback, useState } from "react";

export const useDragAndDrop = ({
  onFileSelect,
  validateFile,
  clearValidation,
  clearUploadError,
}) => {
  const [isDragOver, setIsDragOver] = useState(false);

  const selectFile = useCallback(
    (file) => {
      clearValidation();
      clearUploadError();
      onFileSelect(file);
      validateFile(file);
    },
    [clearUploadError, clearValidation, onFileSelect, validateFile]
  );

  const handleDragOver = useCallback((event) => {
    event.preventDefault();
    setIsDragOver(true);
  }, []);

  const handleDragLeave = useCallback((event) => {
    event.preventDefault();
    setIsDragOver(false);
  }, []);

  const handleDrop = useCallback(
    (event) => {
      event.preventDefault();
      setIsDragOver(false);

      const file = event.dataTransfer.files?.[0];

      if (file) {
        selectFile(file);
      }
    },
    [selectFile]
  );

  const handleFileInput = useCallback(
    (event) => {
      const file = event.target.files?.[0];

      if (file) {
        selectFile(file);
      }

      event.target.value = "";
    },
    [selectFile]
  );

  return {
    isDragOver,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleFileInput,
  };
};
